export interface ProductoResultado{
    iddecinvproductoresultado: number,
    iddecinvproyectoprodtermin: number,
    resultado: string,
}

export function GetVoidProductoResultado():ProductoResultado{
    return{
        iddecinvproductoresultado: 0,
        iddecinvproyectoprodtermin: 0,
        resultado: "" 
    }
}

export function setProductoResultado(row: any):ProductoResultado{
    return{
        iddecinvproductoresultado: row.iddecinvproductoresultado??0,
        iddecinvproyectoprodtermin: row.iddecinvproyectoprodtermin??0,
        resultado: row.resultado??"" 
    }
}

export function setListProductoResultado(data: Array<any>): Array<ProductoResultado>{
    let list: Array<ProductoResultado> = [];
    data.forEach((item) => {
        const i: ProductoResultado = setProductoResultado(item)
        list.push(i);
    });
    return list;
}